import { Link } from "react-router-dom";
import "./cardnews.scss";
import { ICardResponse } from "../../../core/models";

export interface ICardNewsProps {
  title?: string;
  props?: ICardResponse;
}

const CardNews = ({ title, props }: ICardNewsProps) => {
  const pushEventForCardClick = () => {
    if (window && (window as any)["ReactNativeWebView"]) {
      (window as any)["ReactNativeWebView"].postMessage(
        JSON.stringify({
          message: "eventLogForCountly",
          eventName: "Haberler Tıklama",
          eventSegment: { haberAdi: props?.title, yol: title },
          actionType: "event",
        })
      );
    }
  };

  return (
    <Link
      to={{
        pathname: props?.detailUrl,
      }}
      className="card-news"
      onClick={pushEventForCardClick}
    >
      <img
        src={props?.listImage?.src}
        width={164}
        height={100}
        alt={props?.listImage?.alt}
        style={{ height: "auto", width: "100%" }}
      />
      <div className="card-news__text">
        <div className="date-container">
          <span className="date">{props?.dateAreaFormatted}</span>
          <span className="time ">{props?.readTime}</span>
          <img src={"/icons/clock.svg"} width={16} height={16} alt="clock" />
        </div>
        <span className="title">
          <strong>{props?.title}</strong>
        </span>
        <p className="description">{props?.text}</p>
        <div className="card-news__action">
          <span className="icon icon-arrow-right"></span>
        </div>
      </div>
    </Link>
  );
};

export default CardNews;
